<template>
  <div>

  </div>
</template>

<script>
import svgAsset from '@/assets/DisplayX19229.svg';
// import logger from '@/logger';
import state from '@/state';

const segments = [
  'symbol31',  // Smiley
  'symbol33',  // SET
  'symbol32',  // COM
  'symbol37',  // LEFT
  'symbol30',  // RELAIS1
  'symbol46',  // ACHTUNG
  'symbol47',  // HAND
  'symbol45',  // WARTUNG
  'segment5a2',
  'segment5c',
  'segment5b',
  'segment5d2',
  'symbol36',  // DOWN
  'symbol38',  // CENTER
  'symbol35',  // RIGHT
  'symbol34',  // UP
  'segment5h',
  'segment5o',
  'segment5g',
  'segment5n',
  'segment5i',
  'segment5l',
  'segment5k',
  'segment5m',
  'segment4a2',
  'segment4c',
  'segment4b',
  'segment4d2',
  'segment5a1',
  'segment5e',
  'segment5f',
  'segment5d1',
  'segment4h',
  'segment4o',
  'segment4g',
  'segment4n',
  'segment4i',
  'segment4l',
  'segment4k',
  'segment4m',
  'segment3a2',
  'segment3c',
  'segment3b',
  'segment3d2',
  'segment4a1',
  'segment4e',
  'segment4f',
  'segment4d1',
  'segment3h',
  'segment3o',
  'segment3g',
  'segment3n',
  'segment3i',
  'segment3l',
  'segment3k',
  'segment3m',
  'segment2a2',
  'segment2c',
  'segment2b',
  'segment2d2',
  'segment3a1',
  'segment3e',
  'segment3f',
  'segment3d1',
  'segment2h',
  'segment2o',
  'segment2g',
  'segment2n',
  'segment2i',
  'segment2l',
  'segment2k',
  'segment2m',
  'segment1a2',
  'segment1c',
  'segment1b',
  'segment1d2',
  'segment2a1',
  'segment2e',
  'segment2f',
  'segment2d1',
  'segment1h',
  'segment1o',
  'segment1g',
  'segment1n',
  'segment1i',
  'segment1l',
  'segment1k',
  'segment1m',
  'symbol27',
  'symbol26',
  'symbol4',
  'symbol25',
  'segment1a1',
  'segment1e',
  'segment1f',
  'segment1d1',
  'symbol3',
  'symbol14',
  'symbol49',
  'symbol12',
  'symbol43',  // SONNE
  'symbol10',
  'symbol44',  // FROST
  'symbol9',
  'symbol6',
  'symbol8',
  'symbol7',
  'symbol11',
  'symbol1',
  'symbol2',
  'symbol5',
  'symbol13',
  'symbol17',
  'symbol15',
  'symbol18',
  'symbol22',
  'symbol48',
  'symbol23',
  'symbol24',
  'symbol21',
  'segment6d',
  'segment6g',
  'segment6e',
  'segment6f',
  'symbol19',
  'symbol16',
  'symbol20',
  'symbol29',
  'segment7d',
  'segment7g',
  'segment7e',
  'segment7f',
  'symbol28',
  'segment6b',
  'segment6c',
  'segment6a',
  'segment8d',
  'segment8g',
  'segment8e',
  'segment8f',
  'p7',
  'segment7b',
  'segment7c',
  'segment7a',
  'segment9d',
  'segment9g',
  'segment9e',
  'segment9f',
  'p8',
  'segment8b',
  'segment8c',
  'segment8a',
  'symbol42',  // RANKINE
  'symbol39',  // CELSIUS
  'symbol40',  // FAHRENHEIT
  'dp',
  'symbol41',  // KELVIN
  'segment9b',
  'segment9c',
  'segment9a',
];

export default {
  props: [
    'bridge',
    'displayBuffer',
  ],

  watch: {
    displayBuffer() {
      const activeClass = 'rs-x19229-active';
      const inactiveClass = 'rs-x19229-inactive';

      for (let i = 0; i < segments.length; i++) {
        const segment = segments [i];
        if (segment) {
          const offset = i >> 3;
          const mask = 1 << (i & 7);
          const state = !!(this.displayBuffer [offset] & mask);
          const elements = this.$el.querySelectorAll(`.rs-x19229-${segment}`);
          for (const element of elements) {
            if (state) {
              element.classList.remove(inactiveClass);
              if (!element.classList.contains(activeClass)) {
                element.classList.add(activeClass);
              }
            } else {
              element.classList.remove(activeClass);
              if (!element.classList.contains(inactiveClass)) {
                element.classList.add(inactiveClass);
              }
            }
          }
        }
      }
    }
  },

  methods: {
    getDisplaySvg() {
      return this.$el.innerHTML;
    },
  },

  mounted() {
    state.runAsync(async () => {
      const httpResponse = await fetch(svgAsset);
      if (!httpResponse.ok) {
        throw new Error('Unable to fetch display SVG');
      }

      const svgString = await httpResponse.text();

      this.$el.innerHTML = svgString;

      const svgEl = this.$el.querySelector('svg');
      svgEl.setAttribute('viewBox', '70.7 85.4 71.7 38.6');
      svgEl.setAttribute('width', '100%');
      svgEl.setAttribute('height', '100%');

    });
  }
};
</script>

<style>

</style>
